interface ITeamMemberWithContextMenuColours {
    memberIcon: string;
}

export const teamMemberWithContextMenuColours: ITeamMemberWithContextMenuColours = {
    memberIcon: "#00ff9d"
};
